import { useState } from 'react';
import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { faqs } from '@/mocks/home';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="border-t border-background-200 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <SectionHeading
                kicker="常见问题"
                title="关于观看体验，你可能想知道"
                desc="这里整理了用户问得最多的几个问题。如果还有疑问，欢迎直接给我们发邮件。"
              />
              <Link
                to="/about#contact"
                className="mt-6 inline-flex items-center gap-2 text-sm font-label text-primary-600 transition-colors hover:text-primary-700"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-send-line text-sm" />
                </span>
                仍有疑问，联系我们
              </Link>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <Reveal key={faq.q} delay={index * 50}>
                    <div>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left"
                      >
                        <h3 className="font-heading text-base font-medium text-foreground-950 md:text-lg">
                          {faq.q}
                        </h3>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50 dark:text-foreground-950' : 'bg-background-100 text-foreground-600'
                          }`}
                        >
                          <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'} />
                        </span>
                      </button>
                      {isOpen && (
                        <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600 md:text-base">
                          {faq.a}
                        </p>
                      )}
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;